import { useEffect, useState } from "react";

const TARGET = new Date("2026-08-02T00:00:00Z").getTime();

const computeDays = () => {
  const now = Date.now();
  const diff = TARGET - now;
  if (diff <= 0) return 0;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

/**
 * Eyebrow countdown — text-only variant of <Countdown /> used in the hero
 * eyebrow. Renders as: "ENFORCEMENT IN 95 DAYS · AUGUST 2, 2026".
 */
export const EyebrowCountdown = () => {
  const [days, setDays] = useState(computeDays);

  useEffect(() => {
    const id = setInterval(() => setDays(computeDays()), 60 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span data-testid="hero-eyebrow-countdown">
      Enforcement in <span className="tabular-nums">{days.toLocaleString()}</span> days · August 2, 2026
    </span>
  );
};

export default EyebrowCountdown;
